(function () {
  var ourBtn = document.querySelector('.mv-wishlist-icon');
  var ourBadge = document.querySelector('.mv-wishlist-count');
  if (!ourBtn) return;

  // Click our button → click Froonze's hidden nav link to trigger their modal
  ourBtn.addEventListener('click', function () {
    var froonzeLink = document.querySelector('.frcp-wishlist-nav-link');
    if (froonzeLink) {
      froonzeLink.click();
    }
  });

  // Mirror the count badge from Froonze's element to ours
  function syncCount() {
    var froonzeCount = document.querySelector('.frcp-wishlist-nav-link__count');
    if (!froonzeCount) return;
    var n = parseInt(froonzeCount.getAttribute('data-count') || froonzeCount.textContent, 10);
    if (n > 0) {
      ourBadge.textContent = n;
      ourBadge.classList.add('is-visible');
    } else {
      ourBadge.classList.remove('is-visible');
    }
  }

  function attachObserver() {
    var froonzeCount = document.querySelector('.frcp-wishlist-nav-link__count');
    if (froonzeCount) {
      syncCount();
      new MutationObserver(syncCount).observe(froonzeCount, {
        attributes: true, childList: true, characterData: true, subtree: true
      });
    } else {
      setTimeout(attachObserver, 300);
    }
  }
  attachObserver();
})();
